import { get, put, post } from '../../../lib/api';
import endpoints from '../../../lib/endpoints';
import { PreferenceDefinition, Profile } from '../../../models/user';

export interface APIClient {
  getPreferenceDefinitions(): Promise<PreferenceDefinition[]>;
  getProfile(): Promise<Profile>;
  saveProfile(data: Profile): Promise<Profile>;
  authenticate(email: string): Promise<any>;
}

export interface APIError {
  error: string;
  message: string;
  statusCode: number;
  validation?: {
    source?: string;
    keys: string[];
  };
}

interface MemberDetails {
  given_names?: string,
  last_name?: string,
  dob?: string,
  gender?: string,
  postcode?: string,
  state?: string,
  marital_status?: string,
  nickname?: string,
  avatar?: string,
  retirement_stage?: string,
  pension_status?: string,
}


export default {
  getPreferenceDefinitions: (): Promise<PreferenceDefinition[]> =>
    get(endpoints.userPreferenceDefinitions),
  getProfile: (): Promise<Profile> => get(endpoints.userProfile),
  authenticate: (
    email: string, 
    redirectURL: string, 
    memberDetails: MemberDetails, 
    source: string = 'website'): Promise<any> =>
      post(endpoints.authenticate, { email, ...memberDetails, redirectURL, source }),
  facebookAuthenticate: (data: any): Promise<any> =>
    post(endpoints.facebookAuthenticate, {
      data,
      redirectURL: window.location.href,
    }),
  saveProfile: (profile: Profile['profile']): Promise<Profile> =>
    put(endpoints.userProfile, { profile }),
  saveMemberProfile: (profile: any): Promise<any> =>
    post(endpoints.memberProfile, { profile }),
  collectSubscriber: (
    email: string,
    dataFields: {},
  ): Promise<any> => post(endpoints.collectSubscriber, {email, ...dataFields}),
  updateDotDigitalContact: (
    email: string,
    dataFields: {[key: string]: string | null}[],
  ): Promise<any> => post(endpoints.updateDotDigitalContact, {email, dataFields}),
};
